/**
 *
 * Material UI styles for CustomProgress
 *
 *
 * @see https://material-ui.com/styles/basics
 *
 */

const styles = () => ({
  page: {
    height: '100%',
    left: '50%',
    marginLeft: -20,
    opacity: 0.5,
    position: 'absolute',
    textAlign: 'center',
    top: '40%',
    width: '100%',
    zIndex: 1000,
  },
});

export default styles;
